import React from 'react';
import { Plus } from 'lucide-react';
import { WorkoutSearch } from './WorkoutSearch';
import { WorkoutFilters } from './WorkoutFilters';
import { WorkoutTemplates } from './WorkoutTemplates';
import { WorkoutBuilder } from './WorkoutBuilder';

export function WorkoutLibrary() {
  const [showBuilder, setShowBuilder] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState('');
  const [selectedFilter, setSelectedFilter] = React.useState('all');

  if (showBuilder) {
    return <WorkoutBuilder onClose={() => setShowBuilder(false)} />;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Workout Library</h1>
        <button 
          onClick={() => setShowBuilder(true)}
          className="theme-button px-4 py-2 rounded-lg flex items-center gap-2"
        >
          <Plus className="w-4 h-4" />
          Create Workout
        </button>
      </div>

      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <WorkoutSearch value={searchQuery} onChange={setSearchQuery} />
        </div>
        <WorkoutFilters selected={selectedFilter} onSelect={setSelectedFilter} />
      </div>

      <WorkoutTemplates searchQuery={searchQuery} filter={selectedFilter} />
    </div>
  );
}